import { Skeleton } from "@mui/material";
import CategoryCard from "components/categoryCard/v1";
import { Category } from "interfaces";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import cls from "./v1.module.scss";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { Navigation } from "swiper";

type Props = {
  data?: Category[];
  loading: boolean;
  parent?: string;
};

export default function ShopCategoryList({ data, loading, parent }: Props) {
  const { t } = useTranslation();
  return (
    <div className={cls.container}>
      <h1 className={cls.title}>{t("categories")}</h1>
      <div
        style={{
          display: !loading && data?.length === 0 ? "none" : "block",
          background: "var(primary-bg)",
        }}
      >
        <Swiper
          className={`full-width`}
          modules={[Navigation]}
          navigation
          slidesPerView="auto"
          spaceBetween={10}
        >
          {!!parent && (
            <SwiperSlide style={{ maxWidth: "max-content" }}>
              <Link href={`/shop-category/${parent}`} shallow>
                <div className={cls.card}>
                  <span className={cls.text}>{t("all")}</span>
                </div>
              </Link>
            </SwiperSlide>
          )}
          {loading
            ? Array.from(Array(10).keys()).map((item) => (
                <SwiperSlide key={item} className={cls.swiperSlide}>
                  <Skeleton variant="rectangular" className={cls.shimmer} />
                </SwiperSlide>
              ))
            : data?.map((category) => (
                <SwiperSlide key={category.id} className={cls.swiperSlide}>
                  <CategoryCard data={category} parent={parent} />
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
    </div>
  );
}
